import React, { useContext, useRef, useEffect } from 'react'
import { ThemeContext } from '../App'
import { CheckIcon, CloseIcon, PingIcon } from './Icons'

export const Notification = ({icon, title = "", message ="",position = {top:0, right:0}}) => {
    const closeNotification = useRef()
    const theme = useContext(ThemeContext);

  return (
    <div ref = {closeNotification} style={position} className={`fixed m-2 z-10 grid grid-cols-12 justify-center gap-0.5 py-2 px-3 ${theme.backgroundColor} ${theme.foregroundColor} drop-shadow-lg rounded-full border`}>
        <div className='mx-auto'>
          <span className={`relative flex h-3 w-3 mt-0.5`}>
              <span className={`animate-ping absolute inline-flex h-full w-full rounded-full bg-indigo-400 opacity-75`}></span>
              <span className={`relative inline-flex rounded-full h-3 w-3 bg-indigo-500`}></span>
          </span>
        </div>
        <div className='col-span-10 text-left'>
          <div className='text-sm font-bold'>{title}</div>
          <p className='text-xs flex justify-between items-center font-light'>{message}</p>
        </div>
        <div className='mx-auto' onClick = {() => closeNotification.current.style.visibility = "hidden"}>
            <CloseIcon height='18px' width='18px'/>
        </div>
    </div>
  )
}

export const SuccessNotification = ({title = "Success", message = "",position = {top:0, right:0}}) => {
  const closeNotification = useRef()
  useEffect(() => {
    setTimeout(() => {
      closeNotification.current.style.visibility = "hidden"
    }, 5000);
  }, [])
  
return (
  <div ref = {closeNotification} style={position} className={`fixed m-2 z-20 grid grid-cols-12 justify-center gap-0.5 py-2 px-3 bg-green-500 drop-shadow-lg rounded-full text-white`}>
      <div className='mx-auto'>
        <CheckIcon strokeColor='#fff'/>
      </div>
      <div className='col-span-10 text-left'>
        <div className='text-sm font-bold'>{title}</div>
        <p className='text-xs flex justify-between items-center font-light'>{message}</p>
      </div>
      <div className='mx-auto' onClick = {() => closeNotification.current.style.visibility = "hidden"}>
          <CloseIcon height='18px' width='18px'/>
      </div>
  </div>
)
}